import Vue from 'vue';
import VueRouter from 'vue-router';

import eventRoutes from './event';
import publicRoutes from './public';
import memberDashboardRoutes from './memberDashboard/';
import affiliates from './affiliates';
import promo from './promo';
import credentialCourse from './credentialCourse';

const routes = [...publicRoutes, ...affiliates, ...eventRoutes, ...promo, ...memberDashboardRoutes, ...credentialCourse, {path: '*', redirect: '/'}];

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: '/',
    routes,
    linkActiveClass: 'is-active',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    }
});

import middleware from '../middleware';
middleware(router);

export default router;


